module.exports = __webpack_public_path__ + "img/history-p-500.16b70d34.png";